function UtilityIcon(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='35' height='28.231' viewBox='0 0 35 28.231' {...props}>
      <g id='Raggruppa_399' data-name='Raggruppa 399' transform='translate(-3.5 -7.5)'>
        <path
          id='Tracciato_391'
          data-name='Tracciato 391'
          d='M4.5,11.038A2.538,2.538,0,0,1,7.038,8.5h7.377a3.385,3.385,0,0,1,1.967.63l4.158,2.97a3.385,3.385,0,0,0,1.967.63H34.962A2.538,2.538,0,0,1,37.5,15.269V32.192a2.538,2.538,0,0,1-2.538,2.538H7.038A2.538,2.538,0,0,1,4.5,32.192Z'
          fill='none'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          id='Tracciato_392'
          data-name='Tracciato 392'
          d='M16.174,22.578l1.778,1.453,2.147-.812.37-2.266L18.69,19.5m6.8,8.127-5.4-4.408m9.32,5.049L27.64,26.815l-2.147.812-.37,2.266L26.9,31.346'
          transform='translate(-1.796 -1.692)'
          fill='none'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </g>
    </svg>
  )
}

export default UtilityIcon
